<template>
  <div id="app">
    <audioAuto />
    <router-view />
    <!-- 全局通知窗口 -->
    <NoticeMark />
  </div>
</template>

<script>
import audioAuto from '@/components/audioAuto.vue';
import sseManager from '@/utils/sseManager';
export default {
  components: { audioAuto },
  data() {
    return {
      updateInfo: [
        {
          date: '2026-06-06',
          repair: ['最新服务端下载地址：https://xoaoss001.yyaiya.com/apk/pdServer-dev-5.5.4-7.zip','添加点赞红点展示','修改批量添加邮件和消息的逻辑，改为平均轮流分配（即10条数据分为3用户，a用户为1/4/7/10，b用户为2/5/8，c用户为3/6/9）'],
        },
        // 可以继续添加更多版本，例如：
        // {
        //   date: '2025-7-1',
        //   repair: [
        //     '修复消息发送失败的问题',
        //     '优化界面响应速度'
        //   ],
        //   added: [
        //     '新增主题切换功能',
        //     '支持消息撤回功能'
        //   ]
        // }
      ],
    };
  },
  mounted() {
    // 移除自动调用getVersion，改为登录后手动调用
    // 将更新通知方法挂载到全局，供其他组件调用
    this.$root.checkUpdateNotice = this.checkAndShowUpdateNotice;
  },
  methods: {
    // 检查并显示版本更新通知（供其他组件调用）
    checkAndShowUpdateNotice() {
      this.getVersion();
    },
    getVersion() {
      // 这边是一个获取线上版本号的接口
      // 获取当前最新版本号（取updateInfo数组中的第一个版本）
      const currentVersion =
        this.updateInfo.length > 0 ? this.updateInfo[0].date : null;
      // 获取本地存储的版本号
      const localVersion = localStorage.getItem('version');

      // 如果当前版本号与本地版本号不一致，或本地没有版本号，则弹出更新通知
      if (currentVersion && currentVersion !== localVersion) {
        this.$showUpdateNotice({
          title: '版本更新公告',
          content: this.generateUpdateContent(),
          confirmText: '本次更新不再提醒',
          onConfirm: () => {
            console.log('不再弹出当前版本');
            // 点击"不再弹出"按钮时，存储当前版本号，本版本不再弹出
            localStorage.setItem('version', currentVersion);
          },
          onClose: () => {
            console.log('关闭');
            // 通过其他方式关闭时，不设置版本号，下次还会继续弹出
          },
        });
      }
      // this.$showMaintenanceNotice({
      //   title: '系统维护通知',
      //   content: `
      //     <div style="text-align: center;">
      //       <h3>⚠️ 系统正在维护中</h3>
      //       <p>维护时间：2024-01-20 02:00 - 04:00</p>
      //       <p>维护期间服务暂不可用，给您带来的不便敬请谅解。</p>
      //       <p>预计维护完成时间：04:00</p>
      //     </div>
      //   `,
      //   showFooter: false // 维护通知可以不显示底部按钮
      // })
    },
    // 生成更新内容HTML
    generateUpdateContent() {
      let contentHtml = `
        <div class="update-content-wrapper" style="max-height: 400px; overflow-y: auto; padding-right: 8px;">
      `;

      // 循环生成每个版本的更新内容
      this.updateInfo.forEach((update, index) => {
        contentHtml += `
          <div class="update-item" style="margin-bottom: ${index < this.updateInfo.length - 1 ? '24px' : '0'
          };">
            <div style="font-size: 22px; font-weight: 600; color: #2c3e50; margin-bottom: 14px;">
              ${update.date}
            </div>
        `;

        // 问题修复部分
        if (update.repair && update.repair.length > 0) {
          contentHtml += `
            <div style="margin-bottom: 16px;">
              <div style="font-size: 16px; font-weight: 500; color: #e74c3c; margin-bottom: 8px; display: flex; align-items: center;">
                <span style="display: inline-block; width: 6px; height: 6px; background-color: #e74c3c; border-radius: 50%; margin-right: 8px;"></span>
                问题修复：
              </div>
              <ul style="margin: 0; padding-left: 20px; color: #5d6d7e;">
          `;
          update.repair.forEach((item, idx) => {
            // 处理长URL，添加换行和样式
            const processedItem = item.replace(/(https?:\/\/[^\s]+)/g, '<span style="word-break: break-all; word-wrap: break-word; display: inline-block; max-width: 100%;">$1</span>');
            contentHtml += `<li style="margin-bottom: 4px; line-height: 1.5; word-wrap: break-word; overflow-wrap: break-word;">${idx + 1
              }.${processedItem}</li>`;
          });
          contentHtml += `</ul></div>`;
        }

        // 新增内容部分
        if (update.added && update.added.length > 0) {
          contentHtml += `
            <div style="margin-bottom: 16px;">
              <div style="font-size: 16px; font-weight: 500; color: #27ae60; margin-bottom: 8px; display: flex; align-items: center;">
                <span style="display: inline-block; width: 6px; height: 6px; background-color: #27ae60; border-radius: 50%; margin-right: 8px;"></span>
                新增内容：
              </div>
              <ul style="margin: 0; padding-left: 20px; color: #5d6d7e;">
          `;
          update.added.forEach((item, idx) => {
            contentHtml += `<li style="margin-bottom: 4px; line-height: 1.5;">${idx + 1
              }.${item}</li>`;
          });
          contentHtml += `</ul></div>`;
        }

        // 提示信息部分（无标题、斜体小字）
        if (update.note && update.note.length > 0) {
          contentHtml += `
            <div style="margin-bottom: 16px;margin-left: 20px;">
          `;
          update.note.forEach((item) => {
            contentHtml += `<div style="font-size: 12px; font-style: italic; color: #95a5a6; line-height: 1.6; margin-bottom: 6px;">${item}</div>`;
          });
          contentHtml += `</div>`;
        }

        contentHtml += `</div>`;
      });

      contentHtml += `
        </div>
        <style>
          .update-content-wrapper::-webkit-scrollbar {
            width: 6px;
          }
          .update-content-wrapper::-webkit-scrollbar-track {
            background: #f1f1f1;
            border-radius: 3px;
          }
          .update-content-wrapper::-webkit-scrollbar-thumb {
            background: #c1c1c1;
            border-radius: 3px;
          }
          .update-content-wrapper::-webkit-scrollbar-thumb:hover {
            background: #a8a8a8;
          }
        </style>
      `;

      return contentHtml;
    },
    // 初始化SSE连接
    initSSE() {
      // 延迟初始化，确保用户已登录
      this.$nextTick(() => {
        setTimeout(() => {
          sseManager.init();
        }, 1000);
      });
    },
  },

  created() {
    // 在应用创建时初始化SSE连接
    this.initSSE();
    // 移除应用启动时的WebSocket初始化，改为在登录成功后或路由守卫中初始化
    // this.initGlobalWebSocket();
  },
  beforeDestroy() {
    // 在应用销毁前断开SSE连接
    sseManager.disconnect();
    // 移除WebSocket断开逻辑，由路由守卫和登录逻辑控制
    // globalWebSocketManager.disconnect();
  },
};
</script>

<style lang="scss">
::v-deep .el-tooltip__popper,
::v-deep .el-tooltip__popper.is-light {
  max-width: 190px !important;
  border-color: none !important;
  background: none !important;
  box-shadow: 0 1px 12px rgba(0, 0, 0, 0.12), 0 6px 9px rgba(0, 0, 0, 0.14);
}
</style>
